<div class="card shadow rounded-3 mb-3">
  <div class="card-body">
    <h5 class="mb-3 text-center">{{ chartTitle }}</h5>
    <div class="d-flex flex-row flex-wrap">

      <!-- LEFT: Chart -->
      <div style="width:50%; padding-right: 1rem;">
        <highcharts-chart [Highcharts]="Highcharts"
                          [options]="chartOptions"
                          style="width: 100%; height: 350px; display: block;">
        </highcharts-chart>
      </div>

      <!-- RIGHT: Table -->
      <div style="width: 50%; padding-left: 1rem; overflow-x: auto;">
        <table class="table table-hover align-middle text-sm border-1">
          <thead class="text-center" style="background-color: #f8f9fa; border-bottom: 2px solid #e0e0e0;">
            <tr>
              <th style="font-weight: bold;">Dept</th>
              <th>
                📅 MONTH
              </th>
              <th style="color: #20c997; font-weight: bold;">{{ metricKey.toUpperCase() }}%</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let group of groupedTableData">
              <tr *ngFor="let row of group.rows; let i = index" class="text-center">
                <td *ngIf="i === 0"
                    [attr.rowspan]="group.rows.length"
                    class="fw-semibold align-middle text-nowrap"
                    style="background-color: #fff; vertical-align: middle;">
                  {{ group.department }}
                </td>
                <td class="fw-semibold text-nowrap">{{ row.MonthName  }}</td>
                <td>{{ row[metricKey] ?? '—' }}%</td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>


    </div>
  </div>
</div>
